import { EdgeProps } from '@xyflow/react';
import { EdgeDeleteButton } from './EdgeDeleteButton';
import { NODE_WIDTH } from 'constants/processMaps';

export const SelfLoopEdge = (
  props: EdgeProps & {
    data?: { onDelete: (id: string) => void; outputCellValue?: number };
  }
) => {
  const { sourceX, sourceY, id, markerEnd, style, data } = props;

  // Calculate the node's approximate width and height

  // Create a larger loop that starts from the right side
  const startX = sourceX + NODE_WIDTH / 2; // Start from right side
  const startY = sourceY - 50;
  const endX = startX;
  const endY = sourceY - 5; // Slightly before the start point

  // Create a path that loops around the right side of the node
  const controlPoint1X = startX + 80; // First control point far to the right
  const controlPoint1Y = startY - 60; // and above
  const controlPoint2X = startX + 80; // Second control point far to the right
  const controlPoint2Y = startY + 60; // and below

  // Use a cubic Bezier curve for smoother control
  const edgePath = `
      M ${startX} ${startY}
      C ${controlPoint1X} ${controlPoint1Y}
      ${controlPoint2X} ${controlPoint2Y}
      ${endX} ${endY}
    `;

  // Calculate the position of "x" button
  const buttonX = startX + 50; // Adjust accordingly
  const buttonY = startY - 20;

  return (
    <>
      <path
        id={id}
        className="react-flow__edge-path"
        d={edgePath}
        markerEnd={markerEnd}
        style={{
          ...style,
          strokeWidth: 2,
        }}
      />
      <EdgeDeleteButton
        x={buttonX}
        y={buttonY}
        onDelete={() => data?.onDelete(id)}
      />
    </>
  );
};
